import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var EditIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M39.3401 9.17998C38.8439 8.68439 38.2542 8.29221 37.6054 8.02614C36.9565 7.76008 36.2613 7.62542 35.56 7.63C34.0581 7.63492 32.6196 8.23551 31.56 9.29998L11.27 29.59C11.1282 29.7352 11.019 29.9091 10.95 30.1L8.07004 38.69C8.00809 38.9042 7.99675 39.1299 8.03689 39.3492C8.07704 39.5686 8.16756 39.7756 8.30136 39.954C8.43515 40.1324 8.60856 40.2773 8.80789 40.3772C9.00722 40.4772 9.22705 40.5295 9.45004 40.53C9.57596 40.5495 9.70413 40.5495 9.83005 40.53L18.43 37.6C18.6179 37.5309 18.7885 37.4217 18.93 37.28L39.2101 17C39.7357 16.4972 40.1563 15.8951 40.4476 15.2286C40.7389 14.5621 40.8952 13.8444 40.9073 13.1171C40.9194 12.3898 40.7871 11.6674 40.518 10.9916C40.249 10.3158 39.8487 9.7 39.3401 9.17998ZM18.83 33.8L14.7101 29.68L30.51 13.89L34.62 18L18.83 33.8ZM13.0901 31.6L16.91 35.42L11.14 37.42L13.0901 31.6ZM37.44 15.18L36.39 16.24L32.2801 12.12L33.33 11.07C33.6204 10.7727 33.9672 10.5364 34.3502 10.375C34.7331 10.2135 35.1445 10.1303 35.56 10.13C36.3073 10.1264 37.0259 10.4174 37.56 10.94C38.1062 11.5182 38.4004 12.2897 38.3779 13.0848C38.3554 13.8799 38.018 14.6335 37.44 15.18Z"
  }));
});
EditIcon.displayName = 'EditIcon';
EditIcon.defaultProps = {
  'aria-label': 'Edit'
};
export default EditIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/EditIcon/index.js
// module id = 1833
// module chunks = 12